<ng-container *ngIf="calculation">
  <div class="note">
    <ng-container
      i18n="@@ShippingCalculation.Message.DeltaSpend"
      *ngIf="calculation.deltaSpend as spend"
    >
      Spend {{ spend | money: calculation.currency }} more to get free delivery.
    </ng-container>

    <ng-container
      i18n="@@ShippingCalculation.Message.MinSpend"
      *ngIf="calculation.minSpend as spend"
    >
      Spend {{ spend | money: calculation.currency }} for free delivery.
    </ng-container>
  </div>
</ng-container>
